module.exports = __webpack_public_path__ + "img/874.fb1966fd.png";